import ClienteManagementPage from '../pages/ClienteManagementPage'

const routes = [
    { name: 'ClienteManagementPage', path: '/cliente-management', component: ClienteManagementPage },
]

export default routes;
